import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-fax-status',
  templateUrl: './fax-status.component.html',
  styleUrls: ['./fax-status.component.scss']
})
export class FaxStatusComponent implements OnInit {
  @Input() status: string;
  @Input() statusInfo: string;

  constructor() { }

  ngOnInit(): void {
  }

}
